import { Button, Divider, Grid } from "@mui/material";
import { prettifyNumber } from "../../lib/prettifier";
import {
  calculateExpectedMoleculeValue,
  calculateProductPerSecond,
  isMoleculeUnlocked,
} from "../../lib/calculator";
import { useContext, useMemo } from "react";
import { GameContext } from "../../provider/GameProvider";
import { getUid } from "../../auth/user";
import { saveGameInCloud } from "../../save/database";
import { SnackbarContext } from "../../provider/SnackbarProvider";
import { DialogContext } from "../../provider/DialogProvider";
import { loadObjectFromLocalStorage } from "../../save/localSave";
import { executeMoleculeCreation } from "../../lib/resets";
import { saveGame } from "../../save/saveCombiner";
import Decimal from "break_infinity.js";

export function TabHeader() {
  const { achievementMultiplier, game, setGame, setTimeProgressArray } =
    useContext(GameContext);
  const { showSnackbar } = useContext(SnackbarContext);
  const { setCreateMoleculeDialogOpen } = useContext(DialogContext);
  const uid = getUid();
  const neutron = game.producers[1];
  const particlesPerSecond = calculateProductPerSecond(
    neutron,
    achievementMultiplier,
    game
  );
  let expectedMolecules = calculateExpectedMoleculeValue(game);
  const expectedMoleculeText = expectedMolecules.notEquals(1)
    ? "Molecules"
    : "Molecule";

  const moleculeText = game.molecule.value.notEquals(1)
    ? "Molecules"
    : "Molecule";
  const hideMcDialog =
    loadObjectFromLocalStorage("hideMoleculeCreationDialog") ?? false;

  const maxParticles = useMemo(() => {
    let max = new Decimal(1e50);
    if (isMoleculeUnlocked("Methane", game)) {
      const methaneLevel = game.molecule.graphNodes["Methane"];
      max = max.times(new Decimal(1e10).pow(methaneLevel));
    }
    return max;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [game.molecule.graphNodes]);

  return (
    <Grid container style={{ paddingBottom: 16, paddingTop: 16 }}>
      <Grid item md={4} xs={4} style={{ paddingBottom: 24 }}>
        {game.molecule.unlocked && (
          <Button
            style={{
              backgroundColor: "transparent",
              borderColor: "darkorange",
              height: 100,
              width: 180,
            }}
            onClick={() => {
              if (!hideMcDialog) {
                setCreateMoleculeDialogOpen(true);
              } else {
                executeMoleculeCreation(game, setGame, setTimeProgressArray);
              }
            }}
          >
            <div>
              <div>Reset for</div>
              <div>
                {prettifyNumber(expectedMolecules)} {expectedMoleculeText}
              </div>
              <div style={{ fontSize: 10 }}>
                (Max: {prettifyNumber(maxParticles)} Particles)
              </div>
            </div>
          </Button>
        )}
      </Grid>
      <Grid
        item
        md={4}
        xs={4}
        style={{
          display: "flex",
          paddingBottom: 16,
        }}
      >
        <div>
          <div
            style={{
              color: "#2196f3",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            {prettifyNumber(game.producers[0].value)} Particles
          </div>
          <div style={{ color: "white", fontSize: 12, textAlign: "center" }}>
            {prettifyNumber(particlesPerSecond)} P/s
          </div>
          {game.molecule.unlocked && (
            <div
              style={{
                alignItems: "center",
                textAlign: "center",
                color: "darkorange",
                paddingTop: 16,
              }}
            >
              {prettifyNumber(game.molecule.value)} {moleculeText}
            </div>
          )}
        </div>
      </Grid>
      <Grid
        item
        md={4}
        xs={4}
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          style={{
            backgroundColor: "transparent",
            maxHeight: 40,
          }}
          onClick={() => {
            saveGame(uid, game);
            showSnackbar("Game saved!");
          }}
        >
          Save
        </Button>
      </Grid>
      <Grid
        item
        md={12}
        xs={12}
        style={{ paddingBottom: 16, paddingInline: 0 }}
      >
        <Divider style={{ width: "100%" }} />
      </Grid>
    </Grid>
  );
}
